import { render, staticRenderFns } from "./CarFavoriteList.vue?vue&type=template&id=11d20756&scoped=true&"
import script from "./CarFavoriteList.vue?vue&type=script&lang=js&"
export * from "./CarFavoriteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d20756",
  null
  
)

export default component.exports